import Vue from "vue";
import App from "./App.vue";
import router from "@/router/index";
import store from "@/store/index.js";
import "swiper/dist/css/swiper.css";
import Vant from "vant";
import "vant/lib/index.css";
import "@/assets/css/index.css";
import "@/assets/font/fontfamily/font_family.css";
import "@/utils/rem";
import BaiduMap from "vue-baidu-map";
import VueTianditu from 'vue-tianditu'
Vue.use(VueTianditu);
Vue.use(Vant);
import {
  RadioGroup,
  Radio,
  Badge,
  Toast,
  Icon,
  Col,
  Row,
  Button,
  Slider,
  Empty,
  Checkbox,
  DatetimePicker
} from "vant";
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Empty);
Vue.use(Badge);
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Col);
Vue.use(Checkbox);
Vue.use(Row);
Vue.use(Button);
Vue.use(Slider);
Vue.use(DatetimePicker);
Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: process.env.VUE_APP_AK
});

import "mint-ui/lib/style.css";
//引入阿里字体图标
import "./assets/font/iconfont.css";
import "./assets/font/demo.css";
//引入mui样式
import "./assets/mui/css/mui.css";
import Mint from "mint-ui";
Vue.use(Mint);
import { Header } from "mint-ui";
Vue.use(Header);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
